import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function modalChangeFormatter({ element, status }) {
  const modalStatus = status ? 'open' : 'close';
  return getGTMEventData(EVENT_NAMES.MODAL_CHANGE, modalStatus, {
    element, modalStatus,
  }, element);
}

export default modalChangeFormatter;
